import {Directive, ElementRef, Input, Renderer2} from '@angular/core';
import moment from 'moment';

@Directive({
    selector: '[ngcExpirationTimeStyle]'
})

export class ExpirationTimeStyleDirective {

    @Input('ngcExpirationTimeStyle') expirationTs: string;
    @Input() entityType = '';

    readonly expirationRequiredEntityList = ['APPLICATION', 'DISTRICT'];


    constructor(
        private renderer: Renderer2,
        private elementRef: ElementRef
    ) { }

    ngOnInit(): void {
        const expirationDateDifference = moment(this.expirationTs).diff(new Date(), 'days');
        const expirationTsRequired = this.expirationRequiredEntityList.indexOf(this.entityType.toUpperCase()) > -1;
        let expirationTsClass = '';

        switch (true) {
            case (moment(this.expirationTs).isSameOrBefore(new Date()) && expirationTsRequired || !this.expirationTs && expirationTsRequired):
                expirationTsClass = 'expired';
                break;

            case (expirationDateDifference >= 0 && expirationDateDifference < 3 && expirationTsRequired):
                expirationTsClass = 'less-then-3-day';
                break;

            case (expirationDateDifference > 0 && expirationDateDifference < 10 && expirationTsRequired):
                expirationTsClass = 'less-then-10-day';
                break;

            case (expirationDateDifference <= 30):
                expirationTsClass = 'less-then-30-day';
                break;

            default:
                expirationTsClass =  '';
        }

        if (expirationTsClass) {
            this.renderer.addClass(this.elementRef.nativeElement, expirationTsClass);
        }
    }
}
